import AnalyticsContainer from '@/containers/analytics/EngagementsContainer';
import AudienceContainer from '@/containers/analytics/AudienceContainer';
import AfstereoContainer from '@/containers/analytics/AfstereoContainer';
import ProgrammingDashboardContainer from '@/containers/analytics/ProgrammingDashboardContainer';
import VoiceIntelligenceContainer from '@/containers/analytics/VoiceIntelligenceContainer';

export default [
  {
    path: '/analytics/engagements',
    name: 'Engagements',
    meta: { requiresAuth: true, action: 'view', subject: 'analytics' },
    component: AnalyticsContainer,
  },
  {
    path: '/analytics/audience',
    name: 'Audience',
    meta: { requiresAuth: true, action: 'view', subject: 'analytics' },
    component: AudienceContainer,
  },
  {
    path: '/analytics/afstereo',
    name: 'Afstereo',
    meta: { requiresAuth: true, action: 'view', subject: 'analytics' },
    component: AfstereoContainer,
  },
  {
    path: '/analytics/programming',
    name: 'ProgrammingDashboard',
    alias: '/analytics/programmingDashboard',
    meta: { requiresAuth: true, action: 'view', subject: 'analytics' },
    component: ProgrammingDashboardContainer,
  },
  {
    path: '/analytics/voice-intelligence',
    name: 'VoiceIntelligence',
    meta: { requiresAuth: true, action: 'view', subject: 'analytics' },
    component: VoiceIntelligenceContainer,
  },
];



// WEBPACK FOOTER //
// ./src/router/analytics.js